import React, { useReducer } from 'react'
import { initialState, StepperReducer } from './reducer';


const StepperStateContext = React.createContext();
const StepperDispatchContext = React.createContext();

export function useStepperState() {
    const context = React.useContext(StepperStateContext);
    if (context === 'undefined') {
        throw new Error('Error stepperStateContext');
    }
    return context;
}

export function useStepperDispatch() {
    const context = React.useContext(StepperDispatchContext);
    if (context === 'undefined') {
        throw new Error('Error stepperStateContext');
    }
    return context;
}

export const StepperProvider = ({ children }) => {
    const [stepper, dispatch] = useReducer(StepperReducer, initialState);
    return (
        <StepperStateContext.Provider value={stepper}>
            <StepperDispatchContext.Provider value={dispatch}>
                {children}
            </StepperDispatchContext.Provider>
        </StepperStateContext.Provider>
    )
}